/* eslint camelcase: 0 */

import { FormTemplate as Data } from '@/typings/api/FormTemplate'
import { Model, createMessages } from '@/helpers/Model'


export class FormTemplatesModel extends Model<Data> {
  public static readonly page_title = createMessages({
    ...Model.page_title,
    create: 'Добавить Шаблон Веб-Формы',
    edit: 'Редактировать Шаблон Веб-Формы',
    view: (data: FormTemplatesModel) => 'Шаблон Веб-Формы «{name}»'
      .replace('{name}', data.name || '...'),
    list: 'Шаблоны Веб-Форм',
  });

  public static readonly modal_delete = createMessages({
    ...Model.modal_delete,
    delete: (data: FormTemplatesModel) => 'Удаление Шаблона Веб-Формы «{name}»'
      .replace('{name}', data?.name ?? '...'),
    delete_all: 'Удаление выбранных Шаблонов Веб-Форм',
  });

  public static getName(data: Data) {
    return data?.name ?? '...'
  }
}
